import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

import { reducerTemplate } from 'store/utils';

import {
  UPDATE_MEDICAL_HISTORY,
  RESET_MEDICAL_HISTORY,
  UPDATE_MEDICATIONS,
  UPDATE_MEDICATION,
  DELETE_MEDICATION,
  RESET_MEDICATIONS,
} from './types';
import { CURRENT, ID, MEDICATIONS } from '.';

const medHistoryReducer = handleActions(
  {
    [UPDATE_MEDICAL_HISTORY]: (_, { payload }) => payload,
    [RESET_MEDICAL_HISTORY]: () => ({}),
  },
  {}
);

const medicationsReducer = reducerTemplate(
  {
    id: ID,
    list: UPDATE_MEDICATIONS,
    item: UPDATE_MEDICATION,
    deleteItem: DELETE_MEDICATION,
    reset: RESET_MEDICATIONS,
  },
  {}
);

export default combineReducers({
  [CURRENT]: medHistoryReducer,
  [MEDICATIONS]: medicationsReducer,
});
